import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GridComponent } from './grid.component';
import { GridItemComponent, GridItemDirective } from './components/item/item.component';

export { GridComponent } from './grid.component';
export { GridItemComponent, GridItemDirective } from './components/item/item.component';

@NgModule({
  declarations: [
    GridComponent,
    GridItemComponent,
    GridItemDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    GridComponent,
    GridItemComponent,
    GridItemDirective
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class GridModule {}
